import React, { useEffect, useState } from 'react'
import logoSC from "../Imagenes/logoSCTKD.webp"
import usuario from "../Imagenes/perfil_default_tkd.png"
import compBg from "../Imagenes/comp-bg.webp"
import { Typography, Button, Modal } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { PDFCertificados } from './PDFcertificados.js'
import { useNavigate } from "react-router"
import HorariosModal from './horariosModal.js';
import CATEGORIES from '../constants';

const Styles = makeStyles({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#0a0d14",
    position: "relative",
    padding: "20px 16px 60px 16px",
    boxSizing: "border-box",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  bg: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${compBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    opacity: 0.25,
    zIndex: 0
  },
  content: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    maxWidth: 360,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: 16
  },
  logo: {
    width: 90,
    height: "auto",
    objectFit: "contain"
  },
  avatarContainer: {
    position: "relative",
    marginBottom: 12
  },
  avatar: {
    width: 140,
    height: 140,
    // borderRadius: "50%",
    objectFit: "cover",
    // border: "3px solid rgba(255, 255, 255, 0.2)",
    boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.5)"
  },
  nombre: {
    color: "#ffffff",
    fontSize: 26,
    fontWeight: 800,
    fontStyle: "italic",
    textTransform: "uppercase",
    letterSpacing: 1,
    textAlign: "center",
    marginBottom: 8,
    textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)"
  },
  puntos: {
    color: "#39ff14",
    fontSize: 64,
    fontWeight: 700,
    textAlign: "center",
    lineHeight: 1,
    textShadow: "0 0 12px rgba(57, 255, 20, 0.6), 0 0 24px rgba(57, 255, 20, 0.3)",
    marginBottom: 4
  },
  puesto: {
    color: "#b3b3b3",
    fontSize: 16,
    fontWeight: 500,
    textAlign: "center",
    marginBottom: 24
  },
  areaBadgeGreen: {
    color: "#ffffff",
    fontSize: 20,
    fontWeight: 900,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 1,
    background: "linear-gradient(180deg, #1a7a2e 0%, #0f4d1c 100%)",
    border: "2px solid rgba(80, 255, 120, 0.8)",
    borderRadius: 12,
    padding: "10px 18px",
    marginBottom: 24,
    boxShadow: "0px 4px 16px rgba(0, 255, 80, 0.35), 0 0 12px rgba(80, 255, 120, 0.25)",
    textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)"
  },
  areaBadgeGray: {
    color: "#ffffff",
    fontSize: 20,
    fontWeight: 900,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 1,
    background: "linear-gradient(180deg, #3a3a3a 0%, #1f1f1f 100%)",
    border: "2px solid rgba(180, 180, 180, 0.6)",
    borderRadius: 12,
    padding: "10px 18px",
    marginBottom: 24,
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.4)",
    textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)"
  },
  buttonGroup: {
    width: "100%",
    maxWidth: 360,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginBottom: 24
  },
  btnPrimary: {
    width: "100%",
    padding: "14px 24px",
    borderRadius: 12,
    textTransform: "uppercase",
    fontWeight: 700,
    fontSize: 15,
    color: "#ffffff",
    letterSpacing: 1,
    background: "linear-gradient(180deg, #990000 0%, #660000 100%)",
    border: "1px solid rgba(255, 0, 0, 0.3)",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
    cursor: "pointer",
    transition: "transform 0.2s ease, filter 0.2s ease",
    outline: "none",
    "&:active": {
      transform: "scale(0.98)",
      filter: "brightness(1.2)"
    },
    "&:disabled": {
      background: "#3a3a3a",
      color: "#8a8a8a",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      boxShadow: "none",
      cursor: "default"
    }
  },
  secondaryRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    width: "100%"
  },
  btnSecondary: {
    flex: "1 1 30%",
    minWidth: 96,
    padding: "14px 16px",
    borderRadius: 12,
    textTransform: "uppercase",
    fontWeight: 700,
    fontSize: 12,
    color: "#ffffff",
    letterSpacing: 0.5,
    background: "linear-gradient(180deg, rgba(130, 40, 40, 0.4) 0%, rgba(90, 20, 20, 0.4) 100%)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    cursor: "pointer",
    transition: "transform 0.2s ease",
    outline: "none",
    "&:active": {
      transform: "scale(0.98)"
    },
    "&:disabled": {
      background: "rgba(60, 60, 60, 0.3)",
      color: "#8a8a8a",
      border: "1px solid rgba(255, 255, 255, 0.06)",
      cursor: "default"
    }
  },
  infoCard: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: "rgba(20, 24, 33, 0.65)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: 16,
    padding: 16,
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    boxSizing: "border-box"
  },
  cardTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#ffffff",
    fontWeight: 700,
    fontSize: 15,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    paddingBottom: 10,
    marginBottom: 12
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: 12,
    columnGap: 16
  },
  gridItemFull: {
    gridColumn: "1 / span 2",
    borderTop: "1px solid rgba(255, 255, 255, 0.06)",
    paddingTop: 8,
    marginTop: 4
  },
  catRow: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  catBar: {
    display: "flex",
    width: 40,
    height: 12,
    borderRadius: 3,
    overflow: "hidden",
    border: "1px solid rgba(255, 255, 255, 0.25)",
    flexShrink: 0
  },
  catBarBase: {
    flex: 4
  },
  catBarPunta: {
    flex: 1
  },
  catBarDan: {
    color: "#ffffff",
    fontSize: 8,
    fontWeight: 700,
    lineHeight: "10px",
    textAlign: "center",
    width: "100%"
  },
  label: {
    color: "#a0aec0",
    fontSize: 13,
    fontWeight: 500,
    marginRight: 6
  },
  value: {
    color: "#ffffff",
    fontSize: 14,
    fontWeight: 600
  },
  logo2: {
    width: 300,
    margin: "0 auto",
    paddingTop: 100
  },
  loadingText: {
    color: "white",
    textAlign: "center"
  },
  loadingSubtext: {
    color: "white",
    textAlign: "center",
    marginTop: 10
  }
})

function Ranking() {
  const navigate = useNavigate()
  const classes = Styles()

  const { dni, liga_id } = useParams();
  const [datosRanking, setDatosRanking] = useState([]);
  const [competidor, setCompetidor] = useState([]);
  const [asistencia, setAsistencia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState("CARGANDO....");
  const [mensaje2, setMensaje2] = useState("Aguarde un instante, por favor");
  const [anio, setAnio] = useState(0);
  const [horario, setHorario] = useState([])
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    if (dni && liga_id) {
      fetchDatosFull();
    }
  }, [dni, liga_id])

  const fetchDatosFull = async () => {
    try {
      setLoading(true)
      let res = await fetch(`${process.env.REACT_APP_BACKEND_LIGA}/Ranking/${dni}&${liga_id}`,
        {
          method: "GET",
          headers: { 'Content-type': 'application/json' },
        })
      let response = await res.json()

      if (response.code === 200) {
        setAsistencia(response.asistencia)
        setAnio(response.anio)
        setDatosRanking(response.ranking)
        setCompetidor(response.competidor)
        setLoading(false)
        fetchHorario();
      } else {
        setMensaje(response.mensaje)
        setMensaje2(response.mensaje2)
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const fetchHorario = async () => {
    try {
      let res = await fetch(`${process.env.REACT_APP_BACKEND_LIGA}/Horario/showHorario/${dni}`,
        {
          method: "GET",
          headers: { 'Content-type': 'application/json' },
        })
      let response = await res.json()

      if (response.code === 200) {
        setHorario(response.horario)
        setLoading(false)
      } else if (response.code === 400) {
        setHorario(null)
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const foto = competidor?.foto == null ? usuario : process.env.REACT_APP_BACKEND_LIGA + "/profilePic/" + competidor.foto

  const DAN_ROMANOS = {
    "PRIMER DAN": "I",
    "SEGUNDO DAN": "II",
    "TERCER DAN": "III",
    "CUARTO DAN": "IV",
    "QUINTO DAN": "V",
    "SEXTO DAN": "VI",
    "SEPTIMO DAN": "VII",
    "OCTAVO DAN": "VIII",
    "NOVENO DAN": "IX",
  }

  const CategoriaBar = (categoria) => {
    if (!categoria) return null
    const key = categoria.trim().toUpperCase()
    const colores = CATEGORIES[key]
    if (!colores) return null

    const romano = DAN_ROMANOS[key]

    if (colores.length === 1) {
      return (
        <div className={classes.catBar}>
          <div className={classes.catBarBase} style={{ backgroundColor: colores[0] }}>
            {romano ? <div className={classes.catBarDan}>{romano}</div> : null}
          </div>
        </div>
      )
    }

    return (
      <div className={classes.catBar}>
        <div className={classes.catBarBase} style={{ backgroundColor: colores[0] }} />
        <div className={classes.catBarPunta} style={{ backgroundColor: colores[1] }} />
      </div>
    )
  }

  const TicketIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 6 }}>
      <path d="M22 10V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4c1.1 0 2 .9 2 2s-.9 2-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54z"/>
    </svg>
  );

  return (
    <div className={classes.root}>
      <div className={classes.bg} />
      {loading === false ? <>
        <div className={classes.content}>
          <div className={classes.header}>
            <img src={logoSC} alt="logo" className={classes.logo} />
          </div>

          <div className={classes.avatarContainer}>
            <img
              src={foto}
              alt="perfil"
              className={classes.avatar}
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = usuario }}
            />
          </div>

          <Typography className={classes.nombre}>{competidor?.nombre?.toUpperCase()}</Typography>
          <Typography className={classes.puntos}>{competidor?.puntos ? Math.round(competidor?.puntos) : ""}</Typography>
          <Typography className={classes.puesto}>
            {competidor?.puesto > 0 ? "Puesto Nro. " + competidor?.puesto : "Sin competencia registrada aun"}
          </Typography>
          <Typography className={competidor?.area != null ? classes.areaBadgeGreen : classes.areaBadgeGray}>
            {competidor?.area != null ? `Compite en área: ${competidor?.area}` : "Sin área asignada"}
          </Typography>

          <div className={classes.buttonGroup}>
            <Button
              className={classes.btnPrimary}
              disabled={asistencia.length > 0 ? false : true}
              onClick={() => PDFCertificados({ asistencia })}
            >
              Certificado
            </Button>
            <div className={classes.secondaryRow}>
              <Button
                className={classes.btnSecondary}
                onClick={() => navigate('/ranking/listado', { state: { datosRanking, competidor } })}
              >
                Ranking
              </Button>
              <Button
                className={classes.btnSecondary}
                disabled={horario !== null ? false : true}
                onClick={() => setModalOpen(true)}
              >
                Horario
              </Button>
              <Button
                className={classes.btnSecondary}
                onClick={() => navigate('/encuentros', { state: { comp_id: competidor?.id, liga_id: datosRanking?.liga_id } })}
              >
                Competencias
              </Button>
              <Button
                className={classes.btnSecondary}
                disabled={!process.env.REACT_APP_TICKET_PLATFORM_URL}
                onClick={() => {
                  const url = process.env.REACT_APP_TICKET_PLATFORM_URL;
                  if (url) {
                    const competitorDni = competidor?.dni ?? dni;
                    try {
                      const target = new URL(url);
                      if (target.pathname === '/' || target.pathname === '') target.pathname = '/sales';
                      if (competitorDni) target.searchParams.set('competitor_dni', competitorDni);
                      window.open(target.toString(), '_blank', 'noopener,noreferrer');
                    } catch (e) {
                      const base = url.replace(/\/?$/, '/sales');
                      const sep = base.includes('?') ? '&' : '?';
                      window.open(competitorDni ? `${base}${sep}competitor_dni=${encodeURIComponent(competitorDni)}` : base, '_blank', 'noopener,noreferrer');
                    }
                  }
                }}
              >
                <TicketIcon /> Entradas
              </Button>
            </div>
          </div>

          <div className={classes.infoCard}>
            <div className={classes.cardTitleContainer}>
              <span>Ficha del Competidor</span>
            </div>
            <div className={classes.gridContainer}>
              <div>
                <span className={classes.label}>DNI:</span>
                <span className={classes.value}>{competidor?.dni}</span>
              </div>
              <div>
                <span className={classes.label}>Liga:</span>
                <span className={classes.value}>{datosRanking.liga_name}</span>
              </div>
              <div>
                <span className={classes.label}>Edad:</span>
                <span className={classes.value}>{competidor?.edad + " Años."}</span>
              </div>
              <div className={classes.gridItemFull}>
                <div className={classes.catRow}>
                  <span className={classes.label}>Categoría:</span>
                  <span className={classes.value}>{competidor?.categoria}</span>
                  {CategoriaBar(competidor?.categoria)}
                </div>
              </div>
              <div className={classes.gridItemFull}>
                <span className={classes.label}>Temporada:</span>
                <span className={classes.value}>{anio}</span>
              </div>
            </div>
          </div>
        </div>
      </>
        : <>
          <div className={classes.logo2}>
            <img src={logoSC} alt="logo" style={{ width: "60%", marginLeft: "20%" }} />
          </div>
          <Typography variant="h5" className={classes.loadingText}>{mensaje}</Typography>
          <Typography variant="body1" className={classes.loadingSubtext}>{mensaje2}</Typography>
        </>
      }
      <Modal open={modalOpen} style={{ display: "flex", flexDirection: "row", width: "100%", height: "auto", alignItems: "center", justifyContent: "center" }}>
        <HorariosModal handleModal={() => setModalOpen(false)} horario={horario} />
      </Modal>
    </div>
  );
}

export default Ranking
